import styled from 'styled-components'
import { Button, Input } from '../ui'

export const ProxyList = styled.div`
	max-height: 400px;
	overflow-y: auto;
	margin-top: 20px;
`

export const ProxyItem = styled.div`
	padding: 16px;
	border: 1px solid #374151;
	border-radius: 8px;
	margin-bottom: 12px;
	background: #1f2937;
	transition: background-color 0.2s ease;

	&:hover {
		background: #374151;
	}
`

export const ProxyInfo = styled.div`
	margin-bottom: 12px;
`

export const ProxyName = styled.div`
	font-weight: 600;
	color: #f9fafb;
	margin-bottom: 4px;
`

export const ProxyAddress = styled.div`
	font-size: 14px;
	color: #9ca3af;
	font-family: monospace;
`

export const SelectButton = styled(Button)`
	padding: 10px 20px;
	font-size: 14px;
	background: #6366f1;
	min-width: 80px;
	height: 36px;
	border-radius: 16px;
	
	&:hover {
		background: #4f46e5;
	}
`

export const EmptyState = styled.div`
	text-align: center;
	padding: 40px 20px;
	color: #9ca3af;
	font-size: 16px;
`

export const SearchInput = styled(Input)`
	margin-bottom: 0;
	margin-top: 20px;
`